import { Link } from "react-router-dom";
import { ArrowRight, HandHeart, Scale } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { Reveal, MaskedLineInView, PalestineFlag } from "../components/Reveal";

export default function Mission() {
  const { L } = useStore();
  return (
    <div className="pt-32 pb-24 pattern-mission min-h-screen" data-testid="mission-page">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <PalestineFlag className="w-8 h-5 rounded-[3px]" />
            <p className="eyebrow mt-6">{L.mission.eyebrow}</p>
          </Reveal>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ivory mt-4" data-testid="mission-title">
            <MaskedLineInView>{L.mission.title.split("\n")[0]}</MaskedLineInView>
            <MaskedLineInView delay={0.12}><span className="text-gold">{L.mission.title.split("\n")[1]}</span></MaskedLineInView>
          </h1>
          <Reveal delay={0.2}>
            <p className="text-sand mt-6 text-sm lg:text-base leading-relaxed" data-testid="mission-lead">{L.mission.lead}</p>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="text-ivory/90 mt-4 text-sm lg:text-base leading-relaxed" data-testid="mission-body">{L.mission.body}</p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-2 gap-7 mt-16">
          <Reveal className="h-full">
            <div className="h-full border border-gold/30 rounded-2xl p-9 bg-onyx/70 flex flex-col items-center justify-center text-center gap-4" data-testid="mission-stat-card">
              <span className="font-display text-6xl lg:text-7xl text-gold">{L.mission.stat}</span>
              <p className="text-ivory/85 text-sm max-w-xs leading-relaxed">{L.mission.statLabel}</p>
              <p className="text-[0.65rem] tracking-[0.2em] uppercase text-gold/70">{L.mission.via}</p>
            </div>
          </Reveal>
          <div className="flex flex-col gap-7">
            <Reveal delay={0.08} className="flex-1">
              <div className="h-full border border-gold/20 rounded-2xl p-8 bg-onyx/50 flex gap-5" data-testid="mission-calc-card">
                <span className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center shrink-0">
                  <Scale className="w-5 h-5 text-gold" strokeWidth={1.4} />
                </span>
                <div>
                  <h3 className="font-display text-xl text-ivory">{L.mission.calcTitle}</h3>
                  <p className="text-ivory/75 text-sm leading-relaxed mt-3">{L.mission.calc}</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.14} className="flex-1">
              <div className="h-full border border-gold/20 rounded-2xl p-8 bg-onyx/50 flex gap-5" data-testid="mission-independence-card">
                <span className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center shrink-0">
                  <HandHeart className="w-5 h-5 text-gold" strokeWidth={1.4} />
                </span>
                <div>
                  <h3 className="font-display text-xl text-ivory">{L.faq.items[9].q}</h3>
                  <p className="text-ivory/75 text-sm leading-relaxed mt-3">{L.mission.notAffiliated}</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-16 text-center">
          <Link to="/shop" data-testid="mission-cta-shop" className="btn-gold inline-flex items-center gap-2 rounded-full px-9 py-4 text-[0.7rem] tracking-[0.25em] uppercase font-semibold">
            {L.mission.ctaShop} <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
